import React from "react";
import { useApp } from "../../hooks/app-context";
import { HeadingComponent } from "../shared/HeadingComponent";
import { SubHeadingComponent } from "../shared/SubHeadingComponent";
const BaseLayoutWrapperComponent = ({
  children,
  heading,
  subHeading
}) => {
  const app = useApp();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col pt-12 md:pt-24 min-h-screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-6 md:mt-8 text-center"
  }, /*#__PURE__*/React.createElement(HeadingComponent, {
    size: "4xl",
    type: "h1"
  }, heading), /*#__PURE__*/React.createElement(SubHeadingComponent, {
    type: "secondary",
    size: "lg",
    className: "font-normal mt-3"
  }, subHeading)), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 space-y-6 flex items-center flex-col"
  }, children));
};
export { BaseLayoutWrapperComponent };